import React from "react"

type GradientDividerProps = {
  orientation?: "vertical" | "horizontal"
  full?: boolean
  className?: string
}

export default function GradientDivider({ orientation = "vertical", full = true, className }: GradientDividerProps) {
  return (
    <div
      className={`${
        orientation === "vertical"
          ? `bg-gradient-to-b w-1 ${full && "h-full"}`
          : `bg-gradient-to-r h-1 ${full && "w-full"}`
      } flex shrink-0 from-[#5a54df00] via-[#5a54df] to-[#5a54df00] ${className}`}
    />
  )
}
